import React, { useState, useRef } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../campofruver-blanco-y-negro-1.png";

const GET_PEDIDO_BY_NUMERO = gql`
  query getPedidoByNumero($numeroPedido: Int!) {
    getPedidoByNumero(numeroPedido: $numeroPedido) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

export default function BuscarPedido() {
  const [numeroPedido, setNumeroPedido] = useState("");
  const [getPedido, { data, loading, error }] = useLazyQuery(GET_PEDIDO_BY_NUMERO);
  const facturaRef = useRef();

  const handleBuscar = () => {
    if (!numeroPedido) return;
    getPedido({
      variables: { numeroPedido: parseInt(numeroPedido, 10) },
    });
  };


const handleDescargarPDF = () => {
  const input = facturaRef.current;
  html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Primera página
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    // Agregar más páginas si el contenido excede el alto
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`Pedido_${numeroPedido}.pdf`);
  });
};


  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const pedido = data?.getPedidoByNumero;

  let productos = [];
  if (pedido?.productos) {
    try {
      productos = JSON.parse(pedido.productos);
    } catch (e) {
      console.error("Error parseando productos:", e);
    }
  }

  const calcularSubtotal = (prod) => {
    if (prod.codigo === "1" || prod.codigo === 1) {
      return prod.precio * prod.cantidad + 200;
    } else {
      return prod.precio * prod.cantidad;
    }
  };

  const total = productos.reduce((sum, prod) => sum + calcularSubtotal(prod), 0);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        padding: "30px",
        maxWidth: "700px",
        margin: "40px auto",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: "#333",
          marginBottom: "20px",
          borderBottom: "2px solid #eee",
          paddingBottom: "10px",
        }}
      >
        Buscar registro de venta
      </h2>

      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
        <input
          type="number"
          value={numeroPedido}
          onChange={(e) => setNumeroPedido(e.target.value)}
          placeholder="Número de pedido"
          style={{
            width: "200px",
            padding: "8px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginRight: "10px",
            fontSize: "14px",
          }}
        />
        <button
          onClick={handleBuscar}
        className="btn btn-salida"
        >
          Buscar
        </button>
      </div>

      {pedido && (
        <div ref={facturaRef} style={{ backgroundColor: "#fff", padding: "20px" }}>
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <img
              src={logo}
              alt="Campo Fruver Logo"
              style={{ width: "90px", height: "auto", marginBottom: "8px" }}
            />
            <p style={{ margin: 0 }}>322 614 0639</p>
            <p style={{ margin: 0 }}>Calle 11 N° 7-16 La Unión Ant.</p>
            <hr />
            <h4 style={{ margin: "10px 0" }}>
              Factura de venta Nº 00{String(pedido.numeroPedido).padStart(4, "0")}-1
            </h4>
          </div>

          <div style={{ marginBottom: "15px", fontSize: "0.95em" }}>
            <p>
              <strong>Fecha:</strong>{" "}
              {new Date(new Date(pedido.fecha).getTime() - 5 * 60 * 60 * 1000).toLocaleDateString(
                "es-CO",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }
              )}
            </p>
            {pedido.nombreCliente && (
              <p>
                <strong>Cliente:</strong> {pedido.nombreCliente}
              </p>
            )}
            {pedido.whatsappCliente && (
              <p>
                <strong>WhatsApp:</strong> {pedido.whatsappCliente}
              </p>
            )}
          </div>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "10px",
              fontSize: "0.9em",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0", borderBottom: "2px solid #ccc" }}>
                <th style={{ textAlign: "left", padding: "8px" }}>Producto</th>
                <th style={{ textAlign: "center", padding: "8px" }}>Cantidad</th>
                <th style={{ textAlign: "right", padding: "8px" }}>P. Unitario</th>
                <th style={{ textAlign: "right", padding: "8px" }}>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {productos.map((p, i) => {
                const subtotal = calcularSubtotal(p);
                const precioVisual = p.codigo === "1" ? p.precio * 1000 + 200 : p.precio;
                return (
                  <tr key={i}>
                    <td style={{ padding: "6px", borderBottom: "1px solid #eee" }}>{p.nombre}</td>
                    <td style={{ textAlign: "center", padding: "6px", borderBottom: "1px solid #eee" }}>
                      {p.cantidad}
                    </td>
                    <td style={{ textAlign: "right", padding: "6px", borderBottom: "1px solid #eee" }}>
                      ${precioVisual.toLocaleString()}
                    </td>
                    <td style={{ textAlign: "right", padding: "6px", borderBottom: "1px solid #eee" }}>
                      ${subtotal.toLocaleString()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div
            style={{
              textAlign: "right",
              fontWeight: "bold",
              fontSize: "1.1em",
              borderTop: "2px solid #ccc",
              paddingTop: "8px",
            }}
          >
            Total: ${total.toLocaleString()}
          </div>

          <div
            style={{
              textAlign: "center",
              marginTop: "15px",
              fontSize: "0.9em",
              color: "#1f1e1e",
            }}
          >
            <h5>Gracias por elegirnos</h5>
            <p>Campo Fruver - {new Date().getFullYear()}</p>
          </div>
        </div>
      )}

      {pedido && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={handleDescargarPDF}
            className="btn btn-salida"
          >
            Descargar PDF
          </button>
        </div>
      )}
    </div>
  );
}
